<div class="app-dialog">
  <header class="app-dialog__header">
    <div class="app-dialog__header-text">
      <h2>{{ 'settings.integration.' + provider + '.notifyAdminDialog.title' | translate }}</h2>
    </div>
    <button mat-icon-button type="button" (click)="close(false)" [attr.aria-label]="'cancel' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="app-dialog__body">
    <form [formGroup]="form" (submit)="submit()" class="notify-admin-dialog__form">
      <div class="notify-admin-dialog__field">
        <label class="notify-admin-dialog__label">{{ 'settings.integration.' + provider + '.notifyAdminDialog.adminEmail' | translate }}</label>
        <mat-form-field appearance="outline">
          <input matInput formControlName="adminEmail" type="email" [errorStateMatcher]="errorStateMatcher">
          <mat-error *ngIf="form.hasError('required', ['adminEmail'])">{{ 'fieldRequired' | translate }}</mat-error>
          <mat-error *ngIf="form.hasError('email', ['adminEmail'])">{{ 'emailInvalid' | translate }}</mat-error>
        </mat-form-field>
      </div>
      <div class="notify-admin-dialog__field">
        <label class="notify-admin-dialog__label">{{ 'settings.integration.' + provider + '.notifyAdminDialog.subject' | translate }}</label>
        <mat-form-field appearance="outline">
          <input matInput formControlName="subject" readonly [errorStateMatcher]="errorStateMatcher">
        </mat-form-field>
      </div>
      <div class="notify-admin-dialog__field">
        <label class="notify-admin-dialog__label">{{ 'settings.integration.' + provider + '.notifyAdminDialog.message' | translate }}</label>
        <mat-form-field appearance="outline">
          <textarea matInput formControlName="message" rows="8" [errorStateMatcher]="errorStateMatcher"></textarea>
        </mat-form-field>
      </div>
    </form>
  </div>

  <footer class="app-dialog__footer">
    <button mat-stroked-button type="button" (click)="close(false)">{{ 'cancel' | translate }}</button>
    <button mat-raised-button color="primary" type="submit" (click)="submit()" [disabled]="sendingRequest">
      <span *ngIf="!sendingRequest">{{ 'send' | translate }}</span>
      <span *ngIf="sendingRequest">{{ 'sending' | translate }}...</span>
    </button>
  </footer>
</div>
